<template>
    <div class="integrations-wrapper">
        <div class="info-card">
            <h2>Как настроить уведомления</h2>
            <p>
                Подпишитесь на бота <a class="integration-link" href="https://t.me/ChameleonOohdeskBot" target="_blank"><strong>@ChameleonOohdeskBot</strong></a> в Telegram.<br />
                После подписки бот отправит вам <strong>API ключ</strong> и <strong>секретный ключ</strong> — введите их в форму.
            </p>
            <p>
                В дальнейшем бот будет использоваться для получения <strong>системных уведомлений</strong>.
            </p>
        </div>

        <IntegrationTelegramCard
            v-for="(item, index) in items"
            :key="index"
            :id="item.id"
            :apiKey="item.apiKey"
            :secretKey="item.secretKey"
            :comment="item.comment"
            :isLoading="isLoading"
            @inputAttribute="onInputAttribute($event, item)"
            @updateItem="onUpdateItem(item)"
            @removeItem="onRemoveItem"
        />

        <IntegrationTelegramCard
            :apiKey="newItem.apiKey"
            :secretKey="newItem.secretKey"
            :comment="newItem.comment"
            :isLoading="isLoading"
            @inputAttribute="onInputNewAttribute"
            @addItem="onAddItem"
        />
    </div>
</template>

<script>

import ServiceIntegrationTelegram from "@/services/ServicesIntegrations/ServiceIntegrationTelegram";
import IntegrationTelegramCard from "@/components/Integrations/IntegrationTelegramCard.vue";
import UtilResponseException from "../../utils/UtilResponseException";
export default {
    name: "ViewSettingsTelegram",
    components: {
        IntegrationTelegramCard
    },

    data() {
        return {
            items: [],
            newItem: {
                id: 0,
                apiKey: '',
                secretKey: '',
                comment: '',
            },
            isLoading: false
        };
    },

    mounted() {
        this.isLoading = true
        ServiceIntegrationTelegram.getTgAccountList((items) => {
            this.items = items
            this.isLoading = false
        })
    },

    methods: {
        onInputNewAttribute(event) {
            const {value, attribute} = event
            this.newItem = {...this.newItem, [attribute]: value}
        },

        onInputAttribute(event, item) {
            const {value, attribute} = event
            const {id = null} = item;
            const index = this.items.findIndex((item) => item.id === id);
            if(index > -1) {
                let items = [...this.items];
                items[index] = {...items[index], [attribute]: value};
                this.items = [...items];
            }
        },

        onAddItem() {
            this.isLoading = true
            ServiceIntegrationTelegram.createTgAccount(this.newItem, (item) => {
                this.items.push(item)
                this.newItem = {
                    id: 0,
                    apiKey: '',
                    secretKey: '',
                    comment: '',
                }
                this.isLoading = false
            }, this.onError)
        },

        onUpdateItem(item){
            this.isLoading = true
            ServiceIntegrationTelegram.updateTgAccount(item, () => {
                this.isLoading = false
            }, this.onError)
        },

        onRemoveItem(accountId) {
            this.isLoading = true
            ServiceIntegrationTelegram.deleteTgAccount(accountId, () => {
                const items = this.items.filter((item) => item.id !== accountId);
                this.items = [...items];
                this.isLoading = false
            }, this.onError)
        },

        onError(exception) {
            UtilResponseException.print(exception)
            this.isLoading = false
        }
    },
};
</script>

<style lang="scss" scoped>
.integration-link {
    display: inline;
}

.integrations-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1.5rem;
    padding: 2rem;
}

.info-card {
    width: 250px;
    min-width: 250px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.5rem;
    color: #1f2937;
    font-size: 0.95rem;
    line-height: 1.5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
    transition: 0.3s ease;

    h2 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 0.75rem;
        color: #111827;
    }

    p {
        margin-bottom: 0.75rem;
    }

    strong {
        color: #fe1060;
        font-weight: 600;
    }
}

</style>
